<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex
        xs12
        md3
        lg3
      >
        <content-browser></content-browser>
      </v-flex>
      <v-flex
        xs12
        md6
        lg6
      >
        <v-layout row wrap>
          <v-flex xs12>
            <layout-editor
              ref="layoutEditor"
              :is-loading="layoutEditorIsLoading"
            ></layout-editor>
          </v-flex>
          <v-flex xs12>
            <timeline-editor></timeline-editor>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        xs12
        md3
        lg3
      >
        <v-layout row wrap>
          <v-flex
            xs12
            md12
            lg12
          >
            <properties-editor></properties-editor>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12
          >
            <widgets-manager></widgets-manager>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-speed-dial
      fixed
      bottom
      right
      open-on-hover
    >
      <v-btn
        slot="activator"
        color="accent"
        dark
        fab
        hover
        @click="saveWidgets()"
      >
        <v-icon>save</v-icon>
      </v-btn>
    </v-speed-dial>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import GenericWidget from '@/store/modules/widget';
import ContentBrowser from './ContentBrowser.vue';
import LayoutEditor from './LayoutEditor.vue';
import TimelineEditor from './TimelineEditor.vue';
import PropertiesEditor from './PropertiesEditor.vue';
import WidgetsManager from './WidgetsManager.vue';

export default {
  directives: { mask },
  components: {
    ContentBrowser,
    LayoutEditor,
    TimelineEditor,
    PropertiesEditor,
    WidgetsManager,
  },
  computed: {
    widgets: {
      get() {
        return this.$store.getters.getWidgets;
      },
    },
    layout: {
      get() {
        return this.$store.getters.getLayout;
      },
    },
    timelinePoints: {
      get() {
        return this.$store.getters.getTimelinePoints;
      },
    },
  },
  data() {
    return {
      apiUrl: window.api_url,
      layoutEditorIsLoading: true,
    };
  },
  mounted() {
    const store = this.$store;

    store.commit('RESET_LAYOUT_STATE');
    store.commit('RESET_WIDGETS_STATE');
    store.commit('RESET_TIMELINE_STATE');
    store.dispatch('FETCH_LAYOUT', parseInt(this.$route.params.id, 10));
    store.dispatch('FETCH_TIMELINE_POINTS', parseInt(this.$route.params.id, 10));

    Object.keys(this.widgets).forEach((widget) => {
      store.unregisterModule(['widgets', widget]);
    });

    axios.get(`${window.api_url}api/layout/${this.$route.params.id}/widgets`)
      .then((response) => {
        this.layoutEditorIsLoading = false;

        response.data.data.forEach((widget) => {
          /* eslint-disable no-restricted-globals */
          if (!(store && store.state && store.state.widgets[name])) {
            store.registerModule(['widgets', `widget${widget.id}`], GenericWidget);
            this.setWidgetData(widget);
          }
          /* eslint-enable */
        });
      });
  },
  methods: {
    setWidgetData(widget) {
      const convertedStates = [];

      Object.keys(widget.data.states).forEach((key) => {
        const tempState = widget.data.states[key];

        tempState.positionX = Math.round(
          widget.data.states[key].positionX
          * (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientWidth / 100) * 100,
        );
        tempState.positionY = Math.round(
          widget.data.states[key].positionY
          * (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientHeight / 100) * 100,
        );
        tempState.opacity *= 100;

        convertedStates.push(tempState);
      });

      const payload = {
        data: [
          {
            path: '',
            key: 'id',
            value: widget.id,
          },
          {
            path: '',
            key: 'name',
            value: widget.name,
          },
          {
            path: '',
            key: 'icon',
            value: widget.icon,
          },
          {
            path: '',
            key: 'component',
            value: widget.component,
          },
          {
            path: '',
            key: 'layoutID',
            value: widget.layout_id,
          },
          {
            path: '',
            key: 'mediaID',
            value: widget.mediaID,
          },
          {
            path: 'data',
            key: 'states',
            value: convertedStates,
          },
          {
            path: 'data',
            key: 'name',
            value: widget.data.name,
          },
          {
            path: 'dataAudio',
            key: 'src',
            value: widget.dataAudio.src,
          },
          {
            path: 'dataAudio',
            key: 'type',
            value: widget.dataAudio.type,
          },
          {
            path: 'dataAudio',
            key: 'loop',
            value: widget.dataAudio.loop,
          },
          {
            path: 'dataAudio',
            key: 'volume',
            value: widget.dataAudio.volume,
          },
          {
            path: '',
            key: 'dataClock',
            value: widget.dataClock,
          },
          {
            path: 'dataImage',
            key: 'src',
            value: widget.dataImage.src,
          },
          {
            path: 'dataImage',
            key: 'preview',
            value: widget.dataImage.preview,
          },
          {
            path: 'dataPdf',
            key: 'src',
            value: widget.dataPdf.src,
          },
          {
            path: 'dataPdf',
            key: 'delay',
            value: widget.dataPdf.delay,
          },
          {
            path: 'dataPdf',
            key: 'loop',
            value: widget.dataPdf.loop,
          },
          {
            path: 'dataText',
            key: 'text',
            value: widget.dataText.text,
          },
          {
            path: 'dataTicker',
            key: 'feeds',
            value: widget.dataTicker.feeds,
          },
          {
            path: 'dataVideo',
            key: 'src',
            value: widget.dataVideo.src,
          },
          {
            path: 'dataVideo',
            key: 'loop',
            value: widget.dataVideo.loop,
          },
          {
            path: 'dataVideo',
            key: 'volume',
            value: widget.dataVideo.volume,
          },
          {
            path: 'dataVideo',
            key: 'hardwareAcceleration',
            value: widget.dataVideo.hardwareAcceleration,
          },
          {
            path: 'dataVideo',
            key: 'playerType',
            value: widget.dataVideo.playerType,
          },
          {
            path: 'dataVnc',
            key: 'address',
            value: widget.dataVnc.address,
          },
          {
            path: 'dataVnc',
            key: 'port',
            value: widget.dataVnc.port,
          },
          {
            path: 'dataVnc',
            key: 'password',
            value: widget.dataVnc.password,
          },
          {
            path: 'dataWeb',
            key: 'src',
            value: widget.dataWeb.src,
          },
          {
            path: 'dataWeb',
            key: 'preview',
            value: widget.dataWeb.preview,
          },
          {
            path: 'dataWeb',
            key: 'delay',
            value: widget.dataWeb.delay,
          },
          {
            path: 'dataYoutube',
            key: 'src',
            value: widget.dataYoutube.src,
          },
          {
            path: 'dataYoutube',
            key: 'type',
            value: widget.dataYoutube.type,
          },
          {
            path: 'dataYoutube',
            key: 'loop',
            value: widget.dataYoutube.loop,
          },
          {
            path: 'dataTwitter',
            key: 'src',
            value: widget.dataTwitter.src,
          },
          {
            path: 'dataTwitter',
            key: 'delay',
            value: widget.dataTwitter.delay,
          },
          {
            path: 'dataRss',
            key: 'src',
            value: widget.dataRss.src,
          },
          {
            path: 'dataRss',
            key: 'delay',
            value: widget.dataRss.delay,
          },
          {
            path: 'dataFacebook',
            key: 'src',
            value: widget.dataFacebook.src,
          },
          {
            path: 'dataFacebook',
            key: 'delay',
            value: widget.dataFacebook.delay,
          },
          {
            path: 'dataMagio',
            key: 'channelId',
            value: widget.dataMagio.channelId,
          },
          {
            path: 'style',
            key: 'x',
            value:
              Math.round(
                widget.style.x
                * (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientWidth / 100) * 100,
              ),
          },
          {
            path: 'style',
            key: 'y',
            value:
              Math.round(
                widget.style.y
                * (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientHeight / 100) * 100,
              ),
          },
          {
            path: 'style',
            key: 'w',
            value:
              Math.round(
                widget.style.w
                * (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientWidth / 100) * 100,
              ),
          },
          {
            path: 'style',
            key: 'h',
            value:
              Math.round(
                widget.style.h
                * (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientHeight / 100) * 100,
              ),
          },
          {
            path: 'style',
            key: 'r',
            value: widget.style.rotation,
          },
          {
            path: 'style',
            key: 'horizontalAlign',
            value: widget.style.horizontalAlign,
          },
          {
            path: 'style',
            key: 'verticalAlign',
            value: widget.style.verticalAlign,
          },
          {
            path: 'style',
            key: 'justifyContent',
            value: widget.style.justifyContent,
          },
          {
            path: 'style',
            key: 'alignItems',
            value: widget.style.alignItems,
          },
          {
            path: 'style',
            key: 'display',
            value: widget.style.display,
          },
          {
            path: 'style',
            key: 'animationDuration',
            value: widget.style.animationDuration,
          },
          {
            path: 'style',
            key: 'backgroundColor',
            value: widget.style.backgroundColor,
          },
          {
            path: 'style',
            key: 'color',
            value: widget.style.color,
          },
          {
            path: 'style',
            key: 'deformation',
            value: widget.style.deformation,
          },
          {
            path: 'style',
            key: 'fontSize',
            value: widget.style.fontSize,
          },
          {
            path: 'style',
            key: 'paddingLeft',
            value: widget.style.paddingLeft,
          },
          {
            path: 'style',
            key: 'paddingTop',
            value: widget.style.paddingTop,
          },
          {
            path: 'style',
            key: 'paddingRight',
            value: widget.style.paddingRight,
          },
          {
            path: 'style',
            key: 'paddingBottom',
            value: widget.style.paddingBottom,
          },
          {
            path: 'style',
            key: 'zIndex',
            value: widget.style.zIndex,
          },
          {
            path: 'style',
            key: 'directorFlags',
            value: this.directorFlagsStringToArray(widget.style.directorFlags),
          },
        ],
      };

      this.$store.dispatch(`widget${widget.id}/UPDATE_WIDGET`, payload);
    },
    directorFlagsStringToArray(strFlags) {
      const arrFlags = [];
      strFlags.split(',').forEach((item, index) => { // eslint-disable-line no-unused-vars
        if (item === '') {
          return;
        }
        let enabled = true;
        let rawItem = item;
        if (item.charAt(0) === '!') {
          rawItem = item.substr(1);
          enabled = false;
        }
        arrFlags.push({
          id: parseInt(rawItem, 10),
          enabled,
        });
      });
      return arrFlags;
    },
    directorFlagsArrayToString(arrFlags) {
      let strFlags = '';
      let safeArrFlags = arrFlags;
      if (typeof (arrFlags) === 'undefined') safeArrFlags = [];
      safeArrFlags.forEach((item, index) => { // eslint-disable-line no-unused-vars
        if (strFlags !== '') strFlags += ',';
        if (!item.enabled) strFlags += '!';
        strFlags += item.id;
      });
      return strFlags;
    },
    saveWidgets() {
      const vm = this;
      const widgets = [];
      /* eslint-disable prefer-destructuring */
      const timelinePoints = this.timelinePoints;
      /* eslint-enable */
      const loadingToast = this.$toasted.show(
        'Saving...',
        {
          singleton: true,
          type: 'info',
          icon: 'hourglass_empty',
        },
      );

      Object.keys(this.widgets).forEach((key) => {
        const statesConverted = [];

        Object.keys(this.widgets[key].data.states).forEach((stateKey) => {
          const tempState = { ...this.widgets[key].data.states[stateKey] };

          tempState.positionX = Math.round(
            tempState.positionX
            / (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientWidth / 100),
          ) / 100;
          tempState.positionY = Math.round(
            tempState.positionY
            / (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientHeight / 100),
          ) / 100;
          tempState.opacity /= 100;

          statesConverted.push(tempState);
        });

        widgets.push({
          name: this.widgets[key].name,
          icon: this.widgets[key].icon,
          component: this.widgets[key].component,
          layout_id: this.layout.id,
          media_id: this.widgets[key].mediaID,
          data: {
            states: statesConverted,
          },
          dataAudio: {
            source: this.widgets[key].dataAudio.src,
            type: this.widgets[key].dataAudio.type,
            loop: this.widgets[key].dataAudio.loop,
            volume: this.widgets[key].dataAudio.volume,
          },
          dataImage: {
            source: this.widgets[key].dataImage.src,
          },
          dataPdf: {
            source: this.widgets[key].dataPdf.src,
            delay: this.widgets[key].dataPdf.delay,
            loop: this.widgets[key].dataPdf.loop,
          },
          dataText: {
            text: this.widgets[key].dataText.text,
          },
          dataTicker: {
            feeds: this.widgets[key].dataTicker.feeds,
          },
          dataVideo: {
            source: this.widgets[key].dataVideo.src,
            loop: this.widgets[key].dataVideo.loop,
            volume: this.widgets[key].dataVideo.volume,
            hardwareAcceleration: this.widgets[key].dataVideo.hardwareAcceleration,
            playerType: this.widgets[key].dataVideo.playerType,
          },
          dataVnc: {
            address: this.widgets[key].dataVnc.address,
            port: this.widgets[key].dataVnc.port,
            password: this.widgets[key].dataVnc.password,
          },
          dataWeb: {
            src: this.widgets[key].dataWeb.src,
            delay: this.widgets[key].dataWeb.delay,
          },
          dataYoutube: {
            src: this.widgets[key].dataYoutube.src,
            type: this.widgets[key].dataYoutube.type,
            loop: this.widgets[key].dataYoutube.loop,
          },
          dataTwitter: {
            src: this.widgets[key].dataTwitter.src,
            delay: this.widgets[key].dataTwitter.delay,
          },
          dataRss: {
            src: this.widgets[key].dataRss.src,
            delay: this.widgets[key].dataRss.delay,
          },
          dataFacebook: {
            src: this.widgets[key].dataFacebook.src,
            delay: this.widgets[key].dataFacebook.delay,
          },
          dataMagio: {
            channelId: this.widgets[key].dataMagio.channelId,
          },
          style: {
            x: Math.round(
              this.widgets[key].style.x
              / (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientWidth / 100),
            ) / 100,
            y: Math.round(
              this.widgets[key].style.y
              / (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientHeight / 100),
            ) / 100,
            width: Math.round(
              this.widgets[key].style.w
              / (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientWidth / 100),
            ) / 100,
            height: Math.round(
              this.widgets[key].style.h
              / (this.$refs.layoutEditor.$refs.layoutEditorCard.$el.clientHeight / 100),
            ) / 100,
            rotation: this.widgets[key].style.r,
            horizontal_align: this.widgets[key].style.horizontalAlign,
            vertical_align: this.widgets[key].style.verticalAlign,
            animation_duration: this.widgets[key].style.animationDuration,
            background_color: this.widgets[key].style.backgroundColor,
            text_color: this.widgets[key].style.color,
            deformation: this.widgets[key].style.deformation,
            font_size: this.widgets[key].style.fontSize,
            padding_left: this.widgets[key].style.paddingLeft,
            padding_top: this.widgets[key].style.paddingTop,
            padding_right: this.widgets[key].style.paddingRight,
            padding_bottom: this.widgets[key].style.paddingBottom,
            z_index: this.widgets[key].style.zIndex,
            directorflags: this.directorFlagsArrayToString(this.widgets[key].style.directorFlags),
          },
        });
      });

      axios.post(`${this.apiUrl}api/widget`, {
        widgets,
      })
        .then((response) => {
          loadingToast.goAway();
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
        })
        .catch((error) => {
          loadingToast.goAway();
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });

      axios.post(`${this.apiUrl}api/timeline`, {
        timelinePoints,
      })
        // .then((response) => {
        //   vm.$toasted.show(response, { duration: 3000, singleton: true, type: 'success' });
        // })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
  },
};
</script>

<style>

.icon-disabled {
  color: rgba(0, 0, 0, 0.26) !important;
}

.vc-chrome {
  box-shadow: none !important;
}

</style>
